/* Portal configurations - global scope */

/* Define a product types for the portal.
 * id: product type's id
 * name: product type's name
 * available:
 */
const helper = {};

const accent_color = 'version1'; // color schema of the portal, yellow, red

const portal_name = 'Appiland';

const activate_website = 1; // 1(all), 2(only portal), 3(only landing)

const landing_name = 'Appiland'; // FirstPortal, EbookPortal

const product_type = 6;

const portal_url = 'appiland.com';

const country_landing_url = [{
    'UK': 'https://premium.appiland.com/RW3Gm3/',
    'EE': 'https://premium.appiland.com/GJP6qW/',
    'LV': 'https://premium.appiland.com/dbG9ok/',
    'LT': 'https://premium.appiland.com/tHW6F9/',
    'SK': 'https://premium.appiland.com/Gd6ZNW/mo/',
	'RO': 'https://premium.appiland.com/vmV22m/click/',
	'FI': 'https://premium.appiland.com/6AER3h/',
    'DK': 'https://premium.appiland.com/LzW6p9/',
    'SE': 'https://premium.appiland.com/L8X8Qp/',
    'PL': 'https://premium.appiland.com/syqOAX/',
    'CH': 'https://premium.appiland.com/iyNNvf/',
    'RS': 'https://premium.appiland.com/9nZMaL/',
    'CZ': 'https://premium.appiland.com/93kNzL/',
    'LU': 'https://premium.appiland.com/NOPfss/',
    'BA': 'https://premium.appiland.com/BaOOp2/'
}];

const country_default_language = {
    'UK': 'EN',
    'LU': 'EN',
    'CH': 'DE'
};

const product_menu_items = [{
        id: 1,
        name: 'Apps',
        available: 1,
        type: 6,
        banner: 1,
        isActive: true,
        countryExclusion: ''
    },
      {
        id: 2,
        name: 'Online Games',
        available: 1,
        type: 1,
        banner: 0,
        isActive: false,
        countryExclusion: ''
    },
    {
        id: 3,
        name: 'Android Games Apps',
        available: 1,
        type: 2,
        banner: 0,
        isActive: false,
        countryExclusion: ''
    },
    {
        id: 4,
        name: 'Videos',
        available: 0,
        type: 5,
        banner: 0,
        isActive: false,
        countryExclusion: ''
    }
];

const language_phones_format = {
    UK: '+44xxxxxxxxx',
	FI: '04xxxxxxxx',
	EE: '5xxxxxxx',
    LV: '2xxxxxxx',
    LT: '6xxxxxxx',
	RO: '07xxxxxxxx',
	SK: '09xxxxxxxx',
    DK: '47xxxxxxxxx',
    SE: '07xxxxxxxx',
    PL: 'xxxxxxxxx',
    CH: '07xxxxxxxx',
    RS: '06xxxxxxxx',
    CZ: '7xxxxxxxx',
    LU: '352xxxxxxxxx',
    SI: '386xxxxxxxx',
    BA: '06xxxxxxx',
    PT: '09xxxxxxx'
};

/*
 * Rating and Favourite feature enabled (1, 0)
 */
const use_rating = 1;
const use_favourite = 1;

// API Base URL
//prod
const API_BASE_URL = 'https://api.hubdelivery.io';
//local
// const API_BASE_URL = 'http://localhost:5001';

// apis
helper.api_PhoneNumber = 'https://api.hubdelivery.io/landing/providePhoneNumberV2';
helper.api_ValidatePin = 'https://api.hubdelivery.io/landing/validatePinCodeV2';
helper.api_SendAccessCodeByEmail = 'https://api.hubdelivery.io/landing/sendAccessCodeByEmail';

helper.api_Search = 'https://api.hubdelivery.io/store/searchProducts';

// tracking api url
helper.ratingsAPI = "https://api.hubdelivery.io/store/addProductRating";
helper.favouriteAPI = "https://api.hubdelivery.io/store/addToFavourite";
helper.favouriteRemoveAPI = "https://api.hubdelivery.io/store/removeFromFavourite";

// Export API_BASE_URL for use in other components
helper.API_BASE_URL = API_BASE_URL;

// tracking default and generated values
helper.affiliate_landing = 'AFFED8bcEzc'; // aff
helper.source_landing = '10PROVID13'; // src
helper.landing_page_id = 'LPC9crQndF8'; // lpc

// apis
helper.landingUrl = country_landing_url;
helper.languagePhoneFormat = language_phones_format;
helper.countryDefaultLanguage = country_default_language;
helper.menu = product_menu_items;
helper.portal_name = portal_name;
helper.portal_type = product_type;
helper.landing_name = landing_name;
helper.portal_url = portal_url;
helper.accent_color = accent_color;
helper.actice_website = activate_website;
helper.hasStars = use_rating;
helper.hasFavourite = use_favourite;

export const helpers = helper;
